import { Button } from "components/ui";
import React, { useEffect, useState } from "react";
// React Hook Form compatibility pattern
let useForm: any, Controller: any;
try {
	const hookForm = require("react-hook-form");
	useForm = hookForm.useForm;
	Controller = hookForm.Controller;
} catch {
	// Fallback implementations if needed
	useForm = () => ({ register: () => {}, handleSubmit: (fn: any) => fn, formState: { errors: {} } });
	Controller = ({ render, ...props }: any) => render({ onChange: () => {}, onBlur: () => {}, value: '', name: props.name });
}
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { useOrganizations } from "contexts/Organizations";
import { Radio, Space } from 'antd';
import { renderInput } from "components/FormComponents";
import FormErrorMessage from "components/FormErrorMessage/FormErrorMessage";
import { FileExcelOutlined } from "@ant-design/icons";

interface FormFields {
	linkName: string;
	linkType: string;
}

interface CreateShareLinkFormProps {
	handleCreateShareLink: (tokenInfo: any) => void;
	visible: boolean;
}


const CreateShareLinkForm = ({handleCreateShareLink, visible}: CreateShareLinkFormProps) => {

	const { currentOrganizationPlan } = useOrganizations();

	const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm({
		defaultValues: {
			linkName: `Sharelink`,
			linkType: (currentOrganizationPlan?.custom?.navigator?.enabled !== true) ? "editor" : "navigator",
		},
	});

	const [loading, setLoading] = useState(false);

	const { t } = useTranslation();

	const radioOptions = [
		{ label: t("app.createToken.radios.navigator"), value: 'navigator' },
		{ label: t("app.createToken.radios.editor"), value: 'editor' },
		// { label: 'vr', value: 'vr' }, VR stays part of editor sharelink as it has always been
	];

	const onSubmit = async (tokenInfo: any) => {
		setLoading(true);
		await handleCreateShareLink({
			name: tokenInfo.linkName,
			type: tokenInfo.linkType
		});
		setLoading(false);
		reset();
	};

	// useEffect(() => {
	// 	// reset();
	// 	setValue("linkType", (currentOrganizationPlan?.custom?.navigator?.enabled === true) ? "navigator" : "editor");
	//   }, [setValue]);

	useEffect(() => {
		if (visible) {
			console.log('resetting form');
			reset({
				linkName: `Sharelink`,
				linkType: "navigator",
			});
			// setValue("linkType", (currentOrganizationPlan?.custom?.navigator?.enabled === true) ? "navigator" : "editor");
		}
	}, [visible]);

	return (
		<StyledFormContainer>
			<StyledInputContainer>
				<Controller
					control={control}
					render={renderInput({
						placeholder: t("app.createToken.placeholder.name"),
					})}
					name="linkName"
					rules={{
						required: t("app.form.error.requiredField") as string,
					}}
					// value={}
				/>
				<FormErrorMessage name="name" errors={errors} />
			</StyledInputContainer>

			<Controller
				control={control}
				name="linkType"
				// defaultValue={currentOrganizationPlan?.custom?.navigator?.enabled !== true ? "editor" : "navigator"}
				render={({ value, onChange, onBlur }: any) => {
					return (
						<Radio.Group
							onChange={(event) => setValue("linkType", event.target.value)} // Use the onChange function from the render prop
							value={value}
							// name="linkType"
							style={{ marginTop: "20px", maxWidth: "90%" }}
						>
							<div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
								{radioOptions.map((option) => {
									const cantUseNavigator = (option.value === 'navigator' && currentOrganizationPlan?.custom?.navigator?.enabled !== true);
									return (
										<Radio
											key={option.value}
											value={option.value}
											checked={value === option.value}
											disabled={cantUseNavigator}
											style={{ width: "100%", textWrap: "wrap" }}
											// onChange={onChange}
										>
											{option.label}

											{(option.value === 'navigator' && currentOrganizationPlan?.custom?.navigator?.enabled !== true) && (
												<>
													<StyledRequestNavigator
														onClick={() => {
															window.location.href = `mailto:support@hegias.com`;
														}}
													>
														{String(t("app.createToken.requestNavigator"))}
													</StyledRequestNavigator>
													<StyledMoreInfoButton
														onClick={(event) => {
															event.preventDefault();
															event.stopPropagation();
															window.open('https://hegias.com/navigator', '_blank');
														}}
													>
														{String(t("app.createToken.moreInfo"))}
													</StyledMoreInfoButton>
												</>
											)}
										</Radio>
								)})}
							</div>
						</Radio.Group>
					);
				}}
			/>




			<Button
				style={{ marginTop: "20px" }}
				onClick={handleSubmit(onSubmit)}
				loading={loading}
				disabled={loading}
			>
				{String(t("app.global.btn.create"))}
			</Button>
		</StyledFormContainer>
	);
};

const StyledFormContainer = styled.form`
	span {
		width: 100%;
	}
	.ant-radio {
		width: unset;
	}
	.ant-radio-inner {
		width: 17px;
		height: 16px;
	}
`;

const StyledInputContainer = styled.div`
	padding-top: 10px;
`;

const StyledRequestNavigator = styled.div`
	color: ${({ theme }) => theme.colors.primary} !important;
	text-decoration: underline;
	cursor: pointer !important;
	margin-top: 10px;
	margin-left: 20px;
`;

const StyledMoreInfoButton = styled.button`
	background-color: ${({ theme }) => theme.colors.primary};
	color: white;
	cursor: pointer;
	margin-top: 10px;
	margin-left: 20px;
	border: none;
	border-radius: ${({ theme }) => theme.border.radius};
	padding: 10px 30px;
	z-index: 50;
	outline: none;
	&:hover {
		cursor: pointer;
		background-color: #9DB042;
	}
	margin-bottom: 15px;
`;


export default CreateShareLinkForm;
